import { IAddressFields, ICountry, IState } from '@checkout/state';
import { matches } from './utils';

export function getOptionsData(dropdownFor: 'Country' | 'State' | undefined, countries: ICountry[], country: string | null):
  ICountry[] | IState[] | undefined {
  switch (dropdownFor) {
    case 'Country':
      return countries;
    case 'State':
      return country ? getStatesItems(countries, country) : undefined;
    default:
      return undefined;
  }
}

export function getStatesItems(countries: ICountry[], country: string | null): IState[] | undefined {
  if (country) {
    const matching = matches('country', country);
    const selectedCountry = countries.find(matching);

    return selectedCountry && selectedCountry.states;
  }
  return undefined;
}

export function isOnlyOneCountry(countries: ICountry[]): boolean {
  return countries && countries[0] && countries.length === 1;
}

export function isAddressAvailable(address: IAddressFields): boolean {
  return Object.keys(address).some((fieldKey: string) => address[fieldKey].visible);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/address.ts